import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../header";
import Footer from "../footer";
import api, { API_URL, showAlert, AuthContext, Stars, toNaira } from "../util/api";
import PremiumLoader from "../loading";
import "./DoctorProfile.css"; // <-- NEW CSS
import SEO from "../Seo";

// ReadMore Component
const ReadMore = ({ text, max = 120 }) => {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  if (text.length <= max) return <p>{text}</p>;
  return (
    <p>
      {open ? text : `${text.substring(0, max)}... `}
      <span
        onClick={() => setOpen(!open)}
        style={{ color: "#5f2eea", cursor: "pointer", fontWeight: 600 }}
      >
        {open ? "Read less" : "Read more"}
      </span>
    </p>
  );
};

export default function DoctorProfileApp() {
  const { User, token } = useContext(AuthContext);
  const { id } = useParams();
  const router = useNavigate();

  const [loading, setLoading] = useState(true);
  const [doctor, setDoctor] = useState({});
  const [availability, setAvailability] = useState([]);
  const [info, setInfo] = useState({});
  const [patientcount, setpatientcount] = useState(0);

  // Ratings
  const [ratingModal, setRatingModal] = useState(false);
  const [ratings, setRatings] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [loadingRatings, setLoadingRatings] = useState(false);
  const ratingBoxRef = useRef();

  // Booking
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({ report: "", booking: "", attachement: null });
  const [submitting, setSubmitting] = useState(false);
  const [progress, setProgress] = useState(0);

  // Fetch Doctor Data
  const fetchDoctors = async () => {
    try {
      const response = await api.get(`${API_URL}/doctor-profile/${id}`);
      if (response.data.status === "success") {
        setDoctor(response.data.doctor);
        setInfo(response.data);
        setpatientcount(response.data.patientcount);
        setAvailability(JSON.parse(response.data.doctor.weekly_availabilities));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Load Ratings
  const loadRatings = async (url = `${API_URL}/doctor/${id}/ratings`) => {
    if (!url || loadingRatings) return;
    setLoadingRatings(true);
    try {
      const res = await api.get(url);
      if (res.data.status === "success") {
        setRatings(prev => [...prev, ...res.data.ratings.data]);
        setNextPage(res.data.ratings.next_page_url);
      } else {
        showAlert("error", "Error", res.data.message || "Failed to load ratings.");
      }
    } catch (err) {
      showAlert("error", "Error", "Failed to load ratings.");
    } finally {
      setLoadingRatings(false);
    }
  };

  useEffect(() => {
    if (!ratingModal) return;
    const box = ratingBoxRef.current;
    const onScroll = () => {
      if (box.scrollTop + box.clientHeight >= box.scrollHeight - 50) loadRatings(nextPage);
    };
    box.addEventListener("scroll", onScroll);
    return () => box.removeEventListener("scroll", onScroll);
  }, [ratingModal, nextPage]);

  useEffect(() => {
    if (!User || !token) router("/login");
    fetchDoctors();
  }, []);

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === "attachement" && files?.[0]) setFormData({ ...formData, attachement: files[0] });
    else setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    setProgress(10);

    const formDataToSend = new FormData();
    Object.keys(formData).forEach(key => formDataToSend.append(key, formData[key]));
    formDataToSend.append("doctor_id", id);

    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      setProgress(50);
      const response = await api.post("/book", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: evt => evt.total && setProgress(Math.round((evt.loaded / evt.total) * 100)),
      });
      const data = response.data;
      if (data.status === "success") {
        router("/payment_options/" + data.id);
        showAlert("success", "Success", data.message || "Form submitted successfully!");
      } else showAlert("error", "Error", data.message || "Form submission failed.");
    } catch {
      showAlert("error", "Error", "An error occurred while submitting the form.");
    } finally {
      setSubmitting(false);
      setTimeout(() => setProgress(0), 1500);
    }
  };

  if (loading) return <PremiumLoader />;

   
  if (doctor.status !== "approved"  && User.id !== doctor.user_id) {
    return (
      <>

        <Navbar menuColor="red" />

        <section className="dp-page" style={{ backgroundColor: "#f4f6fb", minHeight: "30vh" }}>
          {/* HERO */}
          <div className="dp-hero" >
            <div className="dp-hero-inner" >
              <img src={doctor.profilePicture} alt={doctor.name} className="dp-avatar" />
              <div>
                <h1 className="dp-name">{doctor.name}</h1>
                <div className="dp-specialty" style={{ fontWeight: "bolder", fontSize: "25px", }}>
                  The profile of this Doctor is currently under review. Please check back later.
                </div>

              </div>
            </div>
          </div>

        </section>




        <Footer />

      </>

    );
  }

  return (
    <>
      <Navbar menuColor="red" />

        <SEO
          title={`Dr. ${doctor.name} | Online Doctor Consultation`}
        description={`Consult Dr. ${doctor.name}, ${doctor.speciality && JSON.parse(doctor.speciality).join(" | ")}. Book appointment online.`}
        image={doctor.profilePicture}
        
      />


      <section className="dp-page" style={{ backgroundColor: "#f4f6fb" }}>
        {/* HERO */}
        <div className="dp-hero">
          <div className="dp-hero-inner">
            <img src={doctor.profilePicture} alt={doctor.name} className="dp-avatar" />
            <div>
              <h1 className="dp-name">{doctor.name}</h1>
              <div className="dp-specialty">
                {doctor.speciality && JSON.parse(doctor.speciality).join(" | ")}
              </div>
              <div className="dp-metrics">
                <div className="dp-metric">
                  <span>{doctor.experience}</span>Experience
                </div>
                <div className="dp-metric">
                  <span>{patientcount}</span>Patients
                </div>
                <div className="dp-metric">
                  <Stars value={info.average_rating} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="dp-content">
          {/* ABOUT */}
          <div className="dp-card">
            <h3>About Doctor</h3>
            <p>{doctor.bio}</p>
          </div>

          {/* AVAILABILITY */}
          <div className="dp-card">
            <h3>Available Slots</h3>
            {doctor.weekly_availabilities?.map(slot =>
              slot.available === 1 && slot.booked === 0 ? (
                <div onClick={() => setModalOpen(true)} key={slot.id} className="dp-slot">
                  <strong>{slot.day}</strong>
                  <br />
                  {slot.start_time} - {slot.end_time}
                </div>
              ) : null
            )}
            <h4 style={{ marginTop: 16 }}>Fee: {toNaira(doctor.consultationFee)}</h4>

            {doctor.user_id !== User.id ?
              <>

                {doctor.total_availability > 0 ? (
                  <button className="dp-btn" onClick={() => setModalOpen(true)}>
                    Book Consultation
                  </button>
                ) : (
                  <button className="dp-btn" disabled>
                    Not Available
                  </button>
                )}
              </>
              : <>
                <button className="dp-btn" onClick={() => router('/doctor-profile-reg')}>
                  Edit Profile
                </button></>
            }
          </div>
        </div>

        {/* BOOKING MODAL */}
        {modalOpen && (
          <div className="dp-modal" onClick={() => setModalOpen(false)}>
            <div className="dp-modal-box" onClick={e => e.stopPropagation()}>
              <h3>Book with {doctor.name}</h3>
              <form onSubmit={handleSubmit}>
                <label>Choose a slot</label>
                <select required name="booking" value={formData.booking} onChange={handleChange}>
                  <option value="">-- Choose available time --</option>
                  {doctor.weekly_availabilities?.map(slot =>
                    slot.available === 1 && slot.booked === 0 ? (
                      <option key={slot.id} value={slot.id}>
                        {slot.day} {slot.start_time}-{slot.end_time}
                      </option>
                    ) : null
                  )}
                </select>

                <label>Reason/Symptoms For Visit</label>
                <textarea
                  placeholder="Describe your symptoms (optional)"
                  name="report"
                  value={formData.report}
                  onChange={handleChange}
                />

                <label>Attach Document</label>
                <input type="file" name="attachement" onChange={handleChange} />

                {submitting && (
                  <div>
                    <div className="progress" style={{ height: "10px" }}>
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    <p>Submitting... {progress}%</p>
                  </div>
                )}

                <button className="dp-btn" type="submit" disabled={submitting}>
                  {submitting ? "Submitting..." : "Confirm Booking"}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* RATINGS MODAL */}
        {ratingModal && (
          <div className="dp-modal" onClick={() => setRatingModal(false)}>
            <div className="dp-rating-modal" onClick={e => e.stopPropagation()}>
              <h3>Patient Reviews</h3>
              <div ref={ratingBoxRef}>
                {ratings.map((r, i) => (
                  <div key={i} className="dp-review">
                    <strong>{r.patient?.name}</strong>
                    <Stars value={r.patient_rating} />
                    <ReadMore text={r.patient_comment} />
                  </div>
                ))}
                {loadingRatings && <p>Loading more...</p>}
              </div>
              <button className="dp-btn" onClick={() => setRatingModal(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </section>

      <Footer />
    </>
  );
}
